import { useCurrentUser } from '@/lib/auth-service';
import { logWarn } from '@/lib/rum';
import { env } from 'next-runtime-env';
import { useEffect } from 'react';

declare global {
  interface Window {
    Intercom?: IntercomInstance;
  }
}

export type IntercomInstance = Function | undefined;

const fetcher = (url: string) =>
  fetch(url, {
    method: 'POST',
    cache: 'no-store',
    credentials: 'include',
  }).then((res) => res.json());

export const useIntercom = () => {
  const { user } = useCurrentUser();

  useEffect(() => {
    if (typeof window === undefined && !window.Intercom) return;

    if (user) {
      fetcher(`/api/intercom`)
        .then((data) => {
          if (data.error) {
            logWarn('Error fetching user hash', data);
          } else if (typeof window !== undefined && window?.Intercom) {
            window?.Intercom('boot', {
              app_id: env('INTERCOM_APP_ID'),
              user_id: user.id,
              email: user.primaryEmail,
              created_at: Math.floor(user.timeJoined / 1000),
              user_hash: data.user_hash,
            });
          }
        })
        .catch((error) => {
          logWarn('Error initiating Intercom', error);
        });
    }

    return () => {
      if (typeof window !== 'undefined' && window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, [user]);
};
